import get from 'lodash/get';

const styles = ({ margin, color }) => ({
  marginPanelContainer: {
    minHeight: '500px',
    padding: '0 36px',
    paddingBottom: 0,
  },
  paper: {
    paddingRight: '20px',
    marginTop: '20px',
  },
  helpIconContainer: {
    display: 'flex',
  },
  helpIcon: {
    fontSize: 20,
    margin: get(margin, 'm2'),
    verticalAlign: 'middle',
    cursor: 'pointer',
    color: `${get(color, 'link')} !important`,
  },
  userRolesLink: {
    cursor: 'pointer',
    fontSize: 12,
    color: `${get(color, 'link')} !important`,
  },
  usernamerow: {
    alignItems: 'center',
  },
  checkusername: {
    marginBottom: 2,
  },
  verificationInfo: {
    border: `1px solid ${get(color, 'primaryButtonBackground')}`,
    borderRadius: 4,
    display: 'flex',
    marginTop: 12,
    padding: 16,
  },
  verificationError: {
    border: `1px solid ${get(color, 'error')}`,
    borderRadius: 4,
    color: get(color, 'error'),
    display: 'flex',
    marginTop: 12,
    padding: 16,
  },
  verificationIcon: {
    display: 'flex',
  },
  verificationMsg: {
    display: 'flex',
    marginLeft: 4,
  },
});

export default styles;
